var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('exam-form',{attrs:{"exam_prop":_vm.exam_new,"edit_mood":false},on:{"update:exam_prop":function($event){_vm.exam_new=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }